export default __webpack_public_path__ + "static/bg-k-platform-sharing--mobile-f0d81681f225afecba46db0ebb8818a9.jpg";